import React from 'react';
import Slider from 'react-slick';
import { Star } from 'lucide-react';
import './Testimonials.css';

// 1. IMPORTA TUS LOGOS AQUÍ (Ejemplo si los pones en src/assets/images/)
// import logoCliente1 from '../assets/images/cliente1.png';
// import logoCliente2 from '../assets/images/cliente2.png';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Carlos Mendoza',
      position: 'Director de Operaciones',
      company: 'Transportes Rápidos S.A.',
      image: 'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
      quote: 'Desde que implementamos VillaTracking, hemos reducido nuestros costos operativos en un 22% y mejorado significativamente los tiempos de entrega. La plataforma es intuitiva y el soporte técnico es excepcional.',
      rating: 5
    },
    {
      name: 'María Fernández',
      position: 'Gerente de Logística',
      company: 'Distribuidora Nacional',
      image: 'https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
      quote: 'VillaTracking transformó nuestra operación logística. Ahora tenemos control total sobre nuestra flota y podemos ofrecer información precisa a nuestros clientes sobre el estado de sus entregas.',
      rating: 5
    },
    {
      name: 'Roberto Gómez',
      position: 'Propietario',
      company: 'Servicios de Mensajería Express',
      image: 'https://images.pexels.com/photos/1222271/pexels-photo-1222271.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
      quote: 'El módulo de mantenimientos preventivos y las alertas por voz han salvado nuestros vehículos de daños mayores. Es una inversión que se paga sola en el primer mes.',
      rating: 5
    }
  ];

  // 2. ARREGLO DE CLIENTES (Fácil de escalar)
  const clientLogos = [
    { id: 1, name: 'Transportes Rápidos', src: '/img/transportes_rapidos.png' },
    { id: 2, name: 'Distribuidora Nacional', src: '/img/distribuidora_nacional.png' },
    { id: 3, name: 'Seguridad Privada', src: '/img/seguridad_privada.png' },
    { id: 4, name: 'Constructora', src: '/img/constructora.png' },
    { id: 5, name: 'Logística Express', src: '/img/logistica_express.png' },
  ];

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  };

  return (
    <section id="testimonials" className="section section-alt">
      <div className="container">
        <h2 className="section-title">Lo que dicen nuestros clientes</h2>
        <p className="section-subtitle">
          Descubre cómo VillaTracking está ayudando a empresas de diversos sectores 
          a optimizar sus operaciones y mejorar su rentabilidad.
        </p>

        <div className="testimonials-slider">
          <Slider {...sliderSettings}>
            {testimonials.map((testimonial, index) => (
              <div key={index} className="testimonial-slide">
                <div className="testimonial-card">
                  <div className="testimonial-header">
                    <div className="testimonial-image">
                      <img src={testimonial.image} alt={testimonial.name} />
                    </div>
                    <div className="testimonial-info">
                      <h3>{testimonial.name}</h3>
                      <p>{testimonial.position}</p>
                      <p className="company">{testimonial.company}</p>
                      <div className="testimonial-rating">
                        {[...Array(5)].map((_, i) => (
                          <Star
                            key={i}
                            size={16}
                            fill={i < testimonial.rating ? "#FFB400" : "none"}
                            color={i < testimonial.rating ? "#FFB400" : "#CBD5E1"}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="testimonial-quote">
                    <p>"{testimonial.quote}"</p>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>

        {/* 3. SECCIÓN DE LOGOS DINÁMICA */}
        <div className="clients-logos">
          {clientLogos.map((client) => (
            <div key={client.id} className="client-logo">
              {/* Cuando tengas tus logos, cambias el src apuntando a tus variables o rutas */}
              <img src={client.src} alt={`Cliente ${client.name}`} title={client.name} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;